import React from "react";

const CalculatorsPage = () => {
  const calculators = [
    {
      id: "eligibility",
      title: "Loan Eligibility Calculator",
      description: "Check how much loan amount you are eligible for instantly",
      url: "https://homefirstindia.com/home-loan-eligibility-calculator"
    },
    {
      id: "emi",
      title: "EMI Calculator",
      description: "Calculate monthly EMI based on loan amount, tenure, interest",
      url: "https://homefirstindia.com/home-loan-emi-calculator"
    },
    {
      id: "prepay",
      title: "Auto Prepay Calculator",
      description: "Estimate savings and tenure reduction with auto prepayment option",
      url: "https://homefirstindia.com/home-loan-prepayment-calculator"
    },
    {
      id: "pmay",
      title: "PMAY Subsidy Calculator",
      description: "Check PMAY subsidy eligibility and benefits on your home loan",
      url: "https://homefirstindia.com/pmay-subsidy-calculator"
    }
  ];

  const handleCalculatorClick = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="h-full flex flex-col justify-start sm:justify-center items-center gap-3 sm:gap-4 px-3 sm:px-4 py-3 sm:py-4 overflow-hidden">
      <div className="text-center w-full mb-2 sm:mb-3 flex-shrink-0">
        <h1 className="text-lg sm:text-xl md:text-2xl font-semibold text-black mb-2">
          Calculators
        </h1>
        <p className="text-gray-600 text-xs sm:text-sm px-2 break-words" style={{ wordWrap: 'break-word', overflowWrap: 'break-word' }}>
          Planning your home loan? These calculators will help you get quick estimates and make better decisions
        </p>
      </div>
      
      <div className="w-full max-w-full sm:max-w-[85%] flex-1 min-h-0 overflow-hidden flex flex-col">
        <div className="flex-1 overflow-y-auto hide-scrollbar space-y-2 sm:space-y-3" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
          {calculators.map((calculator) => (
            <button
              key={calculator.id}
              onClick={() => handleCalculatorClick(calculator.url)}
              className="w-full bg-white rounded-xl px-3 sm:px-4 py-2.5 sm:py-3 text-left hover:bg-[#E7E5E1] transition-colors shadow-sm border border-gray-100"
            >
              <h3 className="text-xs sm:text-sm font-semibold text-gray-900 mb-1 break-words" style={{ wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                {calculator.title}
              </h3>
              {calculator.description && (
                <p className="text-xs text-gray-600 break-words leading-relaxed" style={{ wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                  {calculator.description}
                </p>
              )}
            </button>
          ))}
        </div>
        
        <button
          onClick={() => window.location.reload()}
          className="w-full px-4 py-2 bg-[#0074bc] text-white text-xs sm:text-sm font-semibold rounded-lg hover:bg-[#005a8f] transition-colors mt-3 sm:mt-4 flex-shrink-0"
        >
          Go to Main Menu
        </button>
      </div>
    </div>
  );
};

export default CalculatorsPage;

